var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 17.332H21C21.6 17.332 22 16.932 22 16.332V13.332C22 12.432 21.3 11.632 20.5 11.432C18.7 10.932 16 10.332 16 10.332C16 10.332 14.7 8.93203 13.8 8.03203C13.3 7.63203 12.7 7.33203 12 7.33203H5C4.4 7.33203 3.9 7.73203 3.6 8.23203L2.2 11.132C2.06758 11.5183 2 11.9237 2 12.332V16.332C2 16.932 2.4 17.332 3 17.332H5",
    stroke: "#345C72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.332C8.10457 19.332 9 18.4366 9 17.332C9 16.2275 8.10457 15.332 7 15.332C5.89543 15.332 5 16.2275 5 17.332C5 18.4366 5.89543 19.332 7 19.332Z",
    stroke: "#345C72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.332H15",
    stroke: "#345C72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19.332C18.1046 19.332 19 18.4366 19 17.332C19 16.2275 18.1046 15.332 17 15.332C15.8954 15.332 15 16.2275 15 17.332C15 18.4366 15.8954 19.332 17 19.332Z",
    stroke: "#345C72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverApp);
export default __webpack_public_path__ + "static/media/driverApp.f830e1d40ccca2aabace832987c593ce.svg";
export { ForwardRef as ReactComponent };